var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.job.isLate)?_c('div',[_c('v-tooltip',{attrs:{"bottom":"","color":_vm.lateColor},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('strong',_vm._g({class:_vm.lateTextColor},on),[_vm._v(_vm._s(_vm.dateValue))])]}}],null,false,3080397303)},[_c('span',[_vm._v("Late")])])],1):_c('div',[_vm._v(" "+_vm._s(_vm.dateValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }